import { border } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
import { BaseButtonStyledProps } from "../types";

export const borderTheme = themed({
    large: {
        "lodestar-light": border.radius10,
        "ursa-light": border.radius35,
    },
    medium: {
        "lodestar-light": border.radius10,
        "ursa-light": border.radius30,
    },
    small: {
        "lodestar-light": border.radius10,
        "ursa-light": border.radius30,
    },
    xsmall: {
        "lodestar-light": border.radius10,
        "ursa-light": border.radius20,
    },
});

export const getButtonBorderRadius = ({ themeMode, size }: BaseButtonStyledProps) => {
    return borderTheme[size](themeMode);
};
